// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3c9b643","885":"266ce577"}[chunkId] + ".chunk.js";
};